module.exports = __webpack_public_path__ + "img/other.47dfef44.png";